import { useQuery } from "@tanstack/react-query"
import { fetchUnits } from "./UnitApi"

export function useUnits() {
    return useQuery(
        {
            queryKey: ['units'],
            queryFn: fetchUnits,
            staleTime: Infinity
        }
    )
}
